import { useState } from 'react';

const testimonials = [
  {
    id: '1',
    name: '张小雨',
    role: '湖南 · 2024年高考',
    score: '考入北京大学',
    university: '北京大学',
    degree: '本科',
    subject: '经济学院',
    content: '我来自湖南农村，家里条件有限。在金榜旺财上，北京的同学分享了很多学习资料，王老师的高考数学课让我从120分提升到了148分！今年我考上了北京大学，感谢这个平台改变了我的命运！',
    avatar: 'https://public.readdy.ai/ai/img_res/833208a176f9caec250d6824cd87cdef.jpg',
    tag: '高考状元',
    tagColor: 'bg-red-500/20 border-red-400/30 text-red-300',
  },
  {
    id: '2',
    name: '李建明',
    role: '上海 · 2024年考研',
    score: '考入复旦大学研究生',
    university: '复旦大学',
    degree: '硕士研究生',
    subject: '新闻传播学院',
    content: '备考考研那段时间压力很大，在金榜旺财的考研社区里认识了很多志同道合的朋友。平台上的考研英语课程质量非常高，帮助我英语从55分提升到了78分，最终成功考入复旦大学！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20male%20student%20smiling%20confidently%2C%20wearing%20glasses%2C%20academic%20setting%2C%20clean%20background%2C%20portrait%20photo%2C%20graduate%20student%20look&width=200&height=260&seq=t002&orientation=portrait',
    tag: '考研上岸',
    tagColor: 'bg-amber-500/20 border-amber-400/30 text-amber-300',
  },
  {
    id: '3',
    name: '王芳芳',
    role: '四川 · 2023年高考',
    score: '考入清华大学',
    university: '清华大学',
    degree: '本科',
    subject: '计算机科学与技术',
    content: '金榜旺财的编程启蒙课让我爱上了计算机，高中时就开始学习Python。平台上的名师资源让我在高考中理综拿到了290分，最终圆梦清华！现在我已经是清华大二学生，还在平台上帮助学弟学妹。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20female%20university%20student%20smiling%2C%20wearing%20Tsinghua%20University%20sweater%2C%20campus%20background%2C%20portrait%20photo%2C%20confident%20expression%2C%20bright%20lighting&width=200&height=260&seq=t003&orientation=portrait',
    tag: '理科尖子',
    tagColor: 'bg-emerald-500/20 border-emerald-400/30 text-emerald-300',
  },
  {
    id: '4',
    name: '陈志远',
    role: '广东 · 2024年考研',
    score: '考入中国人民大学硕士',
    university: '中国人民大学',
    degree: '硕士研究生',
    subject: '法学院',
    content: '法学考研竞争激烈，我在金榜旺财找到了人大法学院的学长辅导，他们的经验分享太宝贵了。平台的法律专业课程系统全面，让我专业课考了140分，顺利上岸人大法学！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20male%20graduate%20student%2C%20wearing%20formal%20shirt%2C%20holding%20law%20books%2C%20clean%20background%2C%20portrait%20photo%2C%20serious%20and%20confident%20expression&width=200&height=260&seq=t004&orientation=portrait',
    tag: '法学硕士',
    tagColor: 'bg-amber-500/20 border-amber-400/30 text-amber-300',
  },
  {
    id: '5',
    name: '刘梦琪',
    role: '浙江 · 2023年高考',
    score: '考入浙江大学',
    university: '浙江大学',
    degree: '本科',
    subject: '医学院',
    content: '学医是我从小的梦想，但生物化学太难了。金榜旺财上的医学预科课程和名师答疑让我豁然开朗，高考生物拿到了96分！现在在浙大医学院，我也在平台上分享学习笔记回馈社会。',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20female%20medical%20student%20smiling%2C%20wearing%20white%20coat%2C%20hospital%20or%20campus%20background%2C%20portrait%20photo%2C%20warm%20and%20caring%20expression&width=200&height=260&seq=t005&orientation=portrait',
    tag: '医学新星',
    tagColor: 'bg-rose-500/20 border-rose-400/30 text-rose-300',
  },
  {
    id: '6',
    name: '赵宇航',
    role: '北京 · 2024年考研',
    score: '考入北京航空航天大学硕士',
    university: '北京航空航天大学',
    degree: '硕士研究生',
    subject: '航空宇航科学与技术',
    content: '航天梦从小就有！在金榜旺财认识了北航的学长，他们分享了专业课备考资料和面试经验。平台的数学课程让我数学考了145分，最终圆梦北航航天专业！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20male%20aerospace%20engineering%20student%2C%20wearing%20university%20jacket%2C%20confident%20smile%2C%20clean%20background%2C%20portrait%20photo%2C%20smart%20and%20ambitious%20look&width=200&height=260&seq=t006&orientation=portrait',
    tag: '航天梦想',
    tagColor: 'bg-sky-500/20 border-sky-400/30 text-sky-300',
  },
  {
    id: '7',
    name: '孙雅婷',
    role: '江苏 · 2023年高考',
    score: '考入南京大学',
    university: '南京大学',
    degree: '本科',
    subject: '文学院',
    content: '语文和英语一直是我的强项，但数学拖了后腿。金榜旺财的数学专项突破课程让我在三个月内数学从98分提升到了132分！最终以总分672分考入南京大学文学院，感谢平台！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20female%20literature%20student%2C%20elegant%20and%20intellectual%20look%2C%20holding%20books%2C%20campus%20background%2C%20portrait%20photo%2C%20warm%20smile%2C%20clean%20background&width=200&height=260&seq=t007&orientation=portrait',
    tag: '文科翘楚',
    tagColor: 'bg-purple-500/20 border-purple-400/30 text-purple-300',
  },
  {
    id: '8',
    name: '吴浩然',
    role: '湖北 · 2024年考研',
    score: '考入武汉大学硕士',
    university: '武汉大学',
    degree: '硕士研究生',
    subject: '经济与管理学院',
    content: '本科普通院校，考研逆袭武大！金榜旺财的考研规划课程帮我制定了科学的备考计划，社区里的学长学姐给了我很多鼓励。最终以总分390分考入武汉大学，人生实现了逆袭！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20male%20graduate%20student%20smiling%20triumphantly%2C%20casual%20academic%20style%2C%20clean%20background%2C%20portrait%20photo%2C%20energetic%20and%20positive%20expression&width=200&height=260&seq=t008&orientation=portrait',
    tag: '逆袭上岸',
    tagColor: 'bg-orange-500/20 border-orange-400/30 text-orange-300',
  },
  {
    id: '9',
    name: '林晓彤',
    role: '福建 · 2023年高考',
    score: '考入厦门大学',
    university: '厦门大学',
    degree: '本科',
    subject: '经济学院',
    content: '厦大是我的梦想学校！金榜旺财上的经济学启蒙课让我对专业充满热情，英语外教课程让我高考英语拿到了138分。现在在厦大经济学院，风景美、学习氛围也超棒！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20female%20student%20smiling%20happily%20by%20the%20sea%20or%20campus%2C%20wearing%20university%20clothes%2C%20portrait%20photo%2C%20sunny%20and%20cheerful%20expression%2C%20clean%20background&width=200&height=260&seq=t009&orientation=portrait',
    tag: '英语达人',
    tagColor: 'bg-teal-500/20 border-teal-400/30 text-teal-300',
  },
  {
    id: '10',
    name: '黄俊杰',
    role: '广西 · 2024年考研',
    score: '考入同济大学硕士',
    university: '同济大学',
    degree: '硕士研究生',
    subject: '建筑与城市规划学院',
    content: '建筑学考研需要专业课和快题设计，金榜旺财上的建筑专业老师给了我非常专业的指导。平台的设计课程让我快题从60分提升到了85分，最终考入同济建筑学院，梦想成真！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20male%20architecture%20student%2C%20creative%20and%20artistic%20look%2C%20holding%20design%20drawings%2C%20clean%20background%2C%20portrait%20photo%2C%20confident%20and%20passionate%20expression&width=200&height=260&seq=t010&orientation=portrait',
    tag: '建筑梦想',
    tagColor: 'bg-amber-500/20 border-amber-400/30 text-amber-300',
  },
  {
    id: '11',
    name: '周思敏',
    role: '山东 · 2023年高考',
    score: '考入上海交通大学',
    university: '上海交通大学',
    degree: '本科',
    subject: '电子信息与电气工程学院',
    content: '交大是理工科学生的圣地！金榜旺财的物理竞赛课程让我在高中就打下了扎实基础，高考物理满分！平台上认识的学长学姐给了我很多专业选择建议，现在在交大读电子工程，超满意！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20female%20engineering%20student%2C%20smart%20and%20confident%2C%20wearing%20university%20hoodie%2C%20clean%20background%2C%20portrait%20photo%2C%20bright%20smile%2C%20STEM%20student%20look&width=200&height=260&seq=t011&orientation=portrait',
    tag: '理工满分',
    tagColor: 'bg-indigo-500/20 border-indigo-400/30 text-indigo-300',
  },
  {
    id: '12',
    name: '马文博',
    role: '陕西 · 2024年考研',
    score: '考入西安交通大学硕士',
    university: '西安交通大学',
    degree: '硕士研究生',
    subject: '机械工程学院',
    content: '西交大是我的目标，备考一年终于上岸！金榜旺财的机械专业课辅导非常专业，老师都是985高校的博士。平台的学习打卡功能让我坚持每天学习8小时，最终以专业课第一名的成绩录取！',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20male%20mechanical%20engineering%20graduate%20student%2C%20wearing%20lab%20coat%20or%20university%20jacket%2C%20clean%20background%2C%20portrait%20photo%2C%20determined%20and%20focused%20expression&width=200&height=260&seq=t012&orientation=portrait',
    tag: '专业第一',
    tagColor: 'bg-red-500/20 border-red-400/30 text-red-300',
  },
];

const universityLogos: Record<string, string> = {
  '北京大学': '北大',
  '清华大学': '清华',
  '复旦大学': '复旦',
  '中国人民大学': '人大',
  '浙江大学': '浙大',
  '北京航空航天大学': '北航',
  '南京大学': '南大',
  '武汉大学': '武大',
  '厦门大学': '厦大',
  '同济大学': '同济',
  '上海交通大学': '交大',
  '西安交通大学': '西交',
};

export default function TestimonialSection() {
  const [activeIdx, setActiveIdx] = useState(0);
  const [page, setPage] = useState(0);
  const perPage = 6;
  const totalPages = Math.ceil(testimonials.length / perPage);
  const visible = testimonials.slice(page * perPage, page * perPage + perPage);

  return (
    <section className="py-20 bg-[#faf9f7]">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <p className="text-red-500 text-xs font-semibold tracking-widest uppercase mb-2">真实学员故事</p>
          <h2 className="text-3xl md:text-4xl font-black text-gray-900 mb-3">
            名校学子 · 亲身见证
          </h2>
          <p className="text-gray-500 text-sm">来自北大、清华、复旦等顶尖高校的学生，用金榜旺财改变了命运</p>
        </div>

        {/* University Tags */}
        <div className="flex flex-wrap justify-center gap-2 mb-10">
          {Object.entries(universityLogos).map(([name, short]) => (
            <span key={name} className="px-3 py-1.5 bg-white border border-gray-200 rounded-full text-xs font-semibold text-gray-600 whitespace-nowrap">
              {short} · {name}
            </span>
          ))}
        </div>

        {/* Cards Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 mb-8">
          {visible.map((t, i) => (
            <div
              key={t.id}
              onClick={() => setActiveIdx(page * perPage + i)}
              className={`bg-gray-900 rounded-2xl overflow-hidden cursor-pointer transition-all hover:scale-[1.02] ${activeIdx === page * perPage + i ? 'ring-2 ring-amber-400' : ''}`}
            >
              <div className="flex gap-0">
                {/* Avatar */}
                <div className="w-28 flex-shrink-0">
                  <img
                    src={t.avatar}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                    style={{ minHeight: '160px' }}
                  />
                </div>
                {/* Info */}
                <div className="p-4 flex flex-col justify-between flex-1 min-w-0">
                  <div>
                    <div className={`inline-flex items-center gap-1 text-xs px-2 py-0.5 rounded-full border mb-2 ${t.tagColor}`}>
                      <i className="ri-trophy-line text-xs"></i>
                      <span className="font-medium">{t.tag}</span>
                    </div>
                    <p className="text-white font-black text-sm">{t.name}</p>
                    <p className="text-gray-400 text-xs mt-0.5">{t.role}</p>
                    <p className="text-amber-400 text-xs font-semibold mt-1">{t.score}</p>
                  </div>
                  <div className="mt-2">
                    <p className="text-gray-300 text-xs leading-relaxed line-clamp-3">{t.content}</p>
                  </div>
                </div>
              </div>
              {/* Bottom bar */}
              <div className="px-4 py-2.5 bg-white/5 border-t border-white/10 flex items-center gap-2">
                <div className="w-5 h-5 flex items-center justify-center bg-amber-400/20 rounded-full flex-shrink-0">
                  <i className="ri-graduation-cap-line text-amber-400 text-xs"></i>
                </div>
                <span className="text-gray-400 text-xs truncate">{t.university} · {t.degree} · {t.subject}</span>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        <div className="flex items-center justify-center gap-3 mb-14">
          <button
            onClick={() => setPage(p => Math.max(0, p - 1))}
            disabled={page === 0}
            className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-200 text-gray-500 hover:border-red-400 hover:text-red-600 transition-all cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
          >
            <i className="ri-arrow-left-s-line"></i>
          </button>
          {Array.from({ length: totalPages }).map((_, i) => (
            <button
              key={i}
              onClick={() => setPage(i)}
              className={`w-2.5 h-2.5 rounded-full transition-all cursor-pointer ${page === i ? 'bg-red-600 w-6' : 'bg-gray-300 hover:bg-gray-400'}`}
            />
          ))}
          <button
            onClick={() => setPage(p => Math.min(totalPages - 1, p + 1))}
            disabled={page === totalPages - 1}
            className="w-9 h-9 flex items-center justify-center rounded-full border border-gray-200 text-gray-500 hover:border-red-400 hover:text-red-600 transition-all cursor-pointer disabled:opacity-30 disabled:cursor-not-allowed"
          >
            <i className="ri-arrow-right-s-line"></i>
          </button>
        </div>

        {/* Stats Row */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
          {[
            { num: '98%', label: '高考升学率', icon: 'ri-graduation-cap-line' },
            { num: '92%', label: '考研上岸率', icon: 'ri-medal-line' },
            { num: '50万+', label: '受益学生', icon: 'ri-user-smile-line' },
            { num: '8000+', label: '认证教师', icon: 'ri-user-star-line' },
          ].map((stat) => (
            <div key={stat.label} className="bg-white rounded-2xl p-6 text-center">
              <div className="w-10 h-10 flex items-center justify-center bg-red-50 rounded-xl mx-auto mb-3">
                <i className={`${stat.icon} text-red-600 text-xl`}></i>
              </div>
              <div className="text-2xl font-black text-gray-900">{stat.num}</div>
              <div className="text-gray-500 text-xs mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
